// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CurrentServerDetailsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type CurrentServerDetailsQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    systemType?: string | null;
    connectionAge?: number | null;
    usesLegacyHttpApi: boolean;
    collectorInfo?: {
      __typename?: "CollectorInfo";
      id: string;
      configFromEnv: boolean;
      monitoringUser?: string | null;
    } | null;
    lastSnapshot?: {
      __typename?: "Snapshot";
      collectorVersionStr: string;
    } | null;
  };
};

export const CurrentServerDetailsDocument = gql`
  query CurrentServerDetails($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      systemType
      connectionAge
      usesLegacyHttpApi
      collectorInfo {
        id
        configFromEnv
        monitoringUser
      }
      lastSnapshot {
        collectorVersionStr
      }
    }
  }
`;

/**
 * __useCurrentServerDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentServerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentServerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentServerDetailsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useCurrentServerDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  > &
    (
      | { variables: CurrentServerDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  >(CurrentServerDetailsDocument, options);
}
export function useCurrentServerDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  >(CurrentServerDetailsDocument, options);
}
// @ts-ignore
export function useCurrentServerDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CurrentServerDetailsQuery,
  CurrentServerDetailsQueryVariables
>;
export function useCurrentServerDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentServerDetailsQuery,
        CurrentServerDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CurrentServerDetailsQuery | undefined,
  CurrentServerDetailsQueryVariables
>;
export function useCurrentServerDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurrentServerDetailsQuery,
        CurrentServerDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CurrentServerDetailsQuery,
    CurrentServerDetailsQueryVariables
  >(CurrentServerDetailsDocument, options);
}
export type CurrentServerDetailsQueryHookResult = ReturnType<
  typeof useCurrentServerDetailsQuery
>;
export type CurrentServerDetailsLazyQueryHookResult = ReturnType<
  typeof useCurrentServerDetailsLazyQuery
>;
export type CurrentServerDetailsSuspenseQueryHookResult = ReturnType<
  typeof useCurrentServerDetailsSuspenseQuery
>;
export type CurrentServerDetailsQueryResult = Apollo.QueryResult<
  CurrentServerDetailsQuery,
  CurrentServerDetailsQueryVariables
>;
